import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocalizedSchemaService } from '../../../services/localized-schema.service';

@Component({
  selector: 'app-immoconnect',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './immoconnect.component.html',
  styleUrl: './immoconnect.component.scss'
})
export class ImmoconnectComponent implements OnInit, OnDestroy {
  private readonly schemaId = 'immoconnect-product-schema';

  constructor(@Inject(DOCUMENT) private document: Document, private schema: LocalizedSchemaService) { }

  ngOnInit(): void {
    if (this.document.getElementById(this.schemaId)) {
      return;
    }

    const script = this.document.createElement('script');
    script.id = this.schemaId;
    script.type = 'application/ld+json';
    script.text = this.schema.serialize({
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'SoftwareApplication',
          name: $localize`ImmoConnect`,
          applicationCategory: 'BusinessApplication',
          operatingSystem: $localize`Webbrowser, Android`,
          url: 'https://www.albcode.de/albcode/immobilienverwaltung/',
          description: $localize`Webbasierte Software für Immobilienverwaltungen mit digitalen Objektakten, Wohneinheiten, Schadensmanagement, E-Mail-Integration, Aufgaben, Dokumenten und Kalender.`,
          featureList: [
            $localize`Verwaltung von Objekten und Wohneinheiten`,
            $localize`Digitale Objekt- und Vorgangsakten`,
            $localize`Schadens- und Instandhaltungsmanagement`,
            $localize`E-Mail-Zuordnung zu Objekten, Schäden, Projekten und Dienstleistungen`,
            $localize`Aufgaben, Dokumente, Anhänge und Notizen`,
            $localize`Teamkalender und native Android-Kalender-App`,
            $localize`Projekte und Dienstleistungen`,
            $localize`Newsletter und Empfängerlisten`,
            $localize`Word- und Excel-Dokumente direkt bearbeiten`
          ],
          provider: {
            '@type': 'Organization',
            name: $localize`AlbCode – Software & Webentwicklung Saliger`,
            url: 'https://www.albcode.de/'
          }
        },
        {
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: $localize`Was ist ImmoConnect?`,
              acceptedAnswer: {
                '@type': 'Answer',
                text: $localize`ImmoConnect ist eine webbasierte Arbeits- und Vorgangsplattform für Immobilienverwaltungen. Sie verbindet Objekte, Wohneinheiten, Kontakte, Schäden, Aufgaben, E-Mails und Dokumente.`
              }
            },
            {
              '@type': 'Question',
              name: $localize`Kann ImmoConnect Schäden und Instandhaltungsvorgänge verwalten?`,
              acceptedAnswer: {
                '@type': 'Answer',
                text: $localize`Ja. Schäden werden strukturiert erfasst und mit Aufgaben, Kontakten, E-Mails, Dokumenten und Notizen in einer nachvollziehbaren Vorgangsakte verbunden.`
              }
            },
            {
              '@type': 'Question',
              name: $localize`Hat ImmoConnect einen Kalender und eine Android-App?`,
              acceptedAnswer: {
                '@type': 'Answer',
                text: $localize`Ja. Termine werden im integrierten Kalender geplant. Die native Android-App stellt den Kalender mit Tag-, Wochen-, Monats- und Agendaansicht auch mobil bereit.`
              }
            }
          ]
        }
      ]
    });
    this.document.head.appendChild(script);
  }

  ngOnDestroy(): void {
    this.document.getElementById(this.schemaId)?.remove();
  }
}
